import { provider_pcp } from "@/config/roles";

import { isAllowed42CFRP2Email } from "../helpers/predicates";
import type { PermissionConfig, PermissionKey } from "../types";

export const PERMISSION_LIST: Record<PermissionKey, PermissionConfig> = {
  patientDiagnosis: {
    allowIf: isAllowed42CFRP2Email,
    description: "Access to view patient diagnosis information",
    excludedRoles: [provider_pcp], // includes care_managers
  },
  reports: {
    allowIf: isAllowed42CFRP2Email,
    description: "Access to reports and analytics",
    excludedRoles: [provider_pcp], // this includes care_managers
  },
};
